module.exports = __webpack_public_path__ + "static/finelite_body_img2-702c1089b49875d8e2aa0948ca24c824.png";